import { render, staticRenderFns } from "./DIconReset.vue?vue&type=template&id=1010c20e&scoped=true&"
import script from "./DIconReset.vue?vue&type=script&lang=js&"
export * from "./DIconReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010c20e",
  null
  
)

export default component.exports